import React from 'react';
import { Card, Row, Col, Table, Typography, Button } from 'antd';
import Title from '../../component/title';
import useTable from '../../component/table';
import MyForm from './form';

const Religion = props => {
    const [, tb] = useTable('/religion', {})
    const [currentReligion, setCurrentReligion] = React.useState(null);
    const [add, setAdd] = React.useState(false);

    const onRow = (record) => {
        return {
            onClick: () => {
                setCurrentReligion(record);
                setAdd(false);
            }
        }
    }

    const addClicked = () => {
        setCurrentReligion(null);
        setAdd(true);
    }

    return (
        <Card title={<Title title={"Master data agama"} actions={<Button type="primary" onClick={addClicked}>Tambah</Button>} />}>
            <Row style={{ height: '100%' }} gutter={32}>
                <Col span={12}>
                    <Card title={"Daftar agama"}>
                        <Table {...tb.tableProps} onRow={onRow} >
                            <Table.Column dataIndex="name" title="Nama agama" />
                        </Table>
                    </Card>
                </Col>
                <Col span={12}>
                    <Card title={add ? "Tambah agama" : "Edit agama"}>
                        {currentReligion === null && !add && <Typography.Text disabled>Silakan pilih agama pada tabel untuk edit</Typography.Text>}
                        {(currentReligion !== null || add) && <MyForm record={currentReligion} edit={!add} onSuccess={() => {
                            setAdd(false);
                            setCurrentReligion(null);
                            tb.fetchData();
                        }} />}
                    </Card>
                </Col>
            </Row>
        </Card >
    )
}

export default Religion;